
const propertySearchPageInitializer = () => {
	const setUpMonitoringForContainer = (container: HTMLElement) => {
		const checkIfNeedsSubmitting = () => {
			const priors = calculatePriors();
			if (checkForDifferences(priors)) {
				const disabledButtons = container.querySelectorAll(".btn--isDisabled");
				for (let i = 0; i < disabledButtons.length; i++) {
					const disabledButton = disabledButtons.item(i);
					disabledButton.classList.add("btn--isEnabled");
					disabledButton.classList.remove("btn--isDisabled");
					disabledButton.querySelector("input").disabled = false;
				}
			} else {
				const enabledButtons = container.querySelectorAll(".btn--isEnabled");
				for (let i = 0; i < enabledButtons.length; i++) {
					const enabledButton = enabledButtons.item(i);
					enabledButton.classList.add("btn--isDisabled");
					enabledButton.classList.remove("btn--isEnabled");
					enabledButton.querySelector("input").disabled = true;
				}
			}
		}

		const calculatePriors = () => {
			const priors = new Map<HTMLElement, string>();
			const inputFields = container.querySelectorAll("input.trackable-input,input[type='checkbox'],input[type='radio']");
			for (let i = 0; i < inputFields.length; i++) {
				const inputField = inputFields.item(i) as HTMLInputElement;
				const existingPrior = inputField.getAttribute("data-prior");
				if (inputField.type === "checkbox" || inputField.type === "radio") {
					priors.set(inputField, inputField.checked === true ? "t" : "f");
					if (existingPrior === null || existingPrior === undefined) {
						inputField.addEventListener("change", (event) => {
							checkIfNeedsSubmitting();
						});
					}
				} else {
					priors.set(inputField, inputField.value);
					if (existingPrior === null || existingPrior === undefined) {
						inputField.addEventListener("input", checkIfNeedsSubmitting);
					}
				}
			}
			const selectFields = container.querySelectorAll("select.trackable-input");
			for (let i = 0; i < selectFields.length; i++) {
				const selectField = selectFields.item(i) as HTMLSelectElement;
				const options = selectField.querySelectorAll("option");
				let selectedStr = "";
				for (let j = 0; j < options.length; j++) {
					if (options.item(j).selected === true) {
						selectedStr = selectedStr + "," + options.item(j).value;
					}
				}
				priors.set(selectField, selectedStr);
				const existingPrior = selectField.getAttribute("data-prior");
				if (existingPrior === null || existingPrior === undefined) {
					selectField.addEventListener("change", checkIfNeedsSubmitting);
				}
			}
			return priors;
		}
		const applyPriors = (priors: Map<HTMLElement, string>) => {
			priors.forEach((v, k) => {
				k.setAttribute("data-prior", v);
			});
		}
		const checkForDifferences = (currents: Map<HTMLElement, string>) => {
			let different = false;
			currents.forEach((v, k) => {
				if (v !== k.getAttribute("data-prior")) {
					different = true;
				}
			});
			return different;
		};

		applyPriors(calculatePriors());
		const updateHandler = (event: Event) => {
			if ((event as any).detail.fireType === 'always') {
				document.removeEventListener('jsfAjaxEvent', updateHandler);
				setUpMonitoringForContainer(document.getElementById(container.id));
			}
		};
		document.addEventListener('jsfAjaxEvent', updateHandler);
	};
	setUpMonitoringForContainer(document.querySelector("form.propertyListing__filterForm"));
};

export default propertySearchPageInitializer;
